import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import logger from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootState from '../redux/root.reducer';
import storage from 'redux-persist/lib/storage';
import rootSaga from './root.saga';

const persistConfig = {
  key: 'root',
  whitelist: ['app'],
  blacklist: [],
  storage
};
const persistedReducer = persistReducer(persistConfig, rootState);
const sagaMiddleware = createSagaMiddleware();

let middleware = [sagaMiddleware];
if (process.env.REACT_APP_REDUX_LOGGER === 'true') {
  // @ts-ignore
  middleware = [...middleware, logger];
}

export const configureStore = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(configureStore);

export const createTestStore = (initializeState: any) => {
  return createStore(rootState, initializeState);
};

export default { configureStore, persistor, createStore };
